/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-06-22 15:37:11
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-14 17:51:19
 */
import { request } from '@/utils/request'
import { IPwdReset, IUserLogin } from './types.d'

const baseUrl = '/identity'

export default {
  login(data: IUserLogin) {
    return request({
      method: 'post',
      url: '/login',
      data,
      notShowErrMsg: true,
      baseUrl: baseUrl
    })
  },
  logout(userId: string) {
    return request({
      method: 'delete',
      url: '/logout',
      data: {
        userId
      },
      baseUrl: baseUrl
    })
  },
  // 自己修改密码
  changePwd(userId, pwd: IPwdReset) {
    return request({
      method: 'put',
      url: '/user/change_own_pw/' + userId,
      data: pwd,
      baseUrl: baseUrl
    })
  },
  getAreaTitle() {
    return request({
      method: 'get',
      url: '/query_headline',
      params: {},
      baseUrl: baseUrl
    })
  },
  checkLogo() {
    return request({
      method: 'get',
      url: '/logo',
      baseUrl: baseUrl
    })
  },
  // 创建用户
  addUser(data) {
    return request({
      method: 'post',
      url: '/users',
      data,
      baseUrl: baseUrl
    })
  },
  // 编辑用户
  editUser({ user_id, ...data }) {
    return request({
      method: 'put',
      url: `/users/${user_id}`,
      data,
      baseUrl: baseUrl
    })
  },
  // 部门查询
  checkDepartList() {
    return request({
      method: 'get',
      url: '/departments',
      baseUrl: baseUrl
    })
  },
  // 新增部门
  addDepart(data) {
    return request({
      method: 'post',
      url: '/departments',
      data,
      baseUrl: baseUrl
    })
  },
  // 编辑部门
  editDepart(data, department_id?: string) {
    return request({
      method: 'put',
      url: `/departments/${department_id}`,
      data,
      baseUrl: baseUrl
    })
  },
  // 删除部门
  deleteDepart(department_id: string) {
    return request({
      method: 'delete',
      url: `/departments/${department_id}`,
      baseUrl: baseUrl
    })
  },
  // 查询用户列表
  checkUserList(department_id: string, params?) {
    return request({
      method: 'get',
      url: `/departments/${department_id}`,
      params,
      baseUrl: baseUrl
    })
  },
  // 批量设置部门
  batchSettingDepart(data) {
    return request({
      method: 'post',
      url: `/department/relations`,
      data,
      baseUrl: baseUrl
    })
  },
  // 删除用户
  deleteUser(userIds) {
    return request({
      method: 'delete',
      url: `/users`,
      data: {
        userIds
      },
      baseUrl: baseUrl
    })
  },
  deleteUserRelation(roleIds: string[], userIds: string[]) {
    return request({
      method: 'delete',
      url: '/user/relations',
      data: {
        roleIds,
        userIds
      }
    })
  },
  // 查询用户身份信息
  checkUserAuth(user_id) {
    return request({
      method: 'get',
      url: `/user/permissions/${user_id}`,
      baseUrl: baseUrl
    })
  },
  // 部门排序
  departToSort(data) {
    return request({
      method: 'put',
      url: `/department/sort`,
      data,
      baseUrl: baseUrl
    })
  },
  deleteRelation(param) {
    return request({
      method: 'delete',
      url: '/user/relations',
      data: param,
      baseUrl: baseUrl
    })
  }
}
